import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { red } from "@mui/material/colors";

// エラーメッセージ表示box
export default function ErrorMessageBox({messages}) {

    if (messages && messages.length > 0) {
      return (
        <Box backgroundColor={red[50]} border="red 1px solid" borderRadius={2} padding={1} marginY={2}>
          {
            messages.map((msg, index) => (
              <Typography key={`errorMessage_${index}`}>{msg}</Typography>
            ))          
          }
        </Box>
      );
    }
  
    return null;
  }